import React, { useState, useEffect } from "react";
import "./BottomBar.css";
import { Link, useLocation } from "react-router-dom";

export default function BottomBar(props) {
  const [colorHomeIcon, setColorHomeIcon] = useState(false);
  const [colorCartIcon, setColorCartIcon] = useState(false);
  const [colorStarIcon, setColorStarIcon] = useState(false);
  const [colorUserIcon, setColorUserIcon] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    if (
      currentPath === "/home" ||
      currentPath === "/download" ||
      currentPath === "/offlineClasses" ||
      currentPath === "/"
    ) {
      setColorHomeIcon(true);
    } else if (
      currentPath === "/shop" ||
      currentPath === "/productsCategory" ||
      currentPath === "/products" ||
      currentPath === "/partialProducts" ||
      currentPath === "/product" ||
      currentPath === "/cart" ||
      currentPath === "/shopPayment" ||
      currentPath === "/productFilter" ||
      currentPath === "/favorites" ||
      currentPath === "/subFilter" ||
      currentPath === "/productsSearch" ||
      currentPath === "/gallery"
    ) {
      setColorCartIcon(true);
    } else if (
      currentPath === "/health" ||
      currentPath === "/calculator" ||
      currentPath === "/calorieCounter" ||
      currentPath === "/magazines" ||
      currentPath === "/magazine" ||
      currentPath.startsWith("/mealCalorieSelector")
    ) {
      setColorStarIcon(true);
    } else if (currentPath === "/userPanel" || currentPath === "/charts") {
      setColorUserIcon(true);
    } else if (
      currentPath === "/tickets" ||
      currentPath === "/newTicket" ||
      currentPath.startsWith("/ticket")
    ) {
      if (props.prevPath === "/home") {
        setColorHomeIcon(true);
      } else if (props.prevPath === "/userPanel") {
        setColorUserIcon(true);
      } else if (props.prevPath === "/health") {
        setColorStarIcon(true);
      }
    }
  }, [currentPath]);

  return (
    <div className="bottomBar centeredFlex">
      <div className="bottomBarBlur"></div>
      <div className="bottomBarIconsWrapper responsiveWidth centeredFlex">
        <Link to="/home" className="link">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19 19"
            id="vector"
            className="bottomBarHomeIcon"
          >
            <path
              id="path"
              d="M 6.635 18.772 L 6.635 15.715 C 6.636 15.466 6.702 15.221 6.827 15.006 C 6.952 14.79 7.132 14.611 7.348 14.487 C 7.564 14.363 7.809 14.298 8.058 14.299 L 10.932 14.299 C 11.309 14.299 11.671 14.448 11.939 14.713 C 12.071 14.844 12.176 15 12.248 15.171 C 12.319 15.343 12.356 15.527 12.356 15.713 L 12.356 18.771 C 12.355 18.932 12.386 19.091 12.447 19.24 C 12.508 19.389 12.598 19.524 12.712 19.638 C 12.826 19.752 12.962 19.843 13.112 19.905 C 13.261 19.966 13.421 19.998 13.583 19.998 L 15.544 19.998 C 16.458 20.001 17.337 19.641 17.987 18.998 C 18.307 18.681 18.562 18.304 18.736 17.889 C 18.91 17.473 18.999 17.027 19 16.577 L 19 7.866 C 18.999 7.503 18.918 7.144 18.762 6.816 C 18.606 6.487 18.38 6.197 18.1 5.966 L 11.434 0.675 C 10.87 0.226 10.167 -0.013 9.447 0 C 8.726 0.013 8.032 0.277 7.485 0.746 L 0.967 5.964 C 0.674 6.189 0.435 6.476 0.268 6.805 C 0.101 7.134 0.009 7.497 0 7.866 L 0 16.566 C 0.002 17.171 0.163 17.764 0.467 18.287 C 0.771 18.809 1.207 19.243 1.732 19.543 C 2.257 19.844 2.851 20.001 3.456 19.999 L 5.372 19.999 C 5.697 20 6.01 19.873 6.241 19.645 C 6.473 19.417 6.605 19.106 6.608 18.781 Z"
              fill={colorHomeIcon ? "#FF4545" : "#ffffff"}
            />
          </svg>
        </Link>
        <Link to="/health" className="link">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 23"
            id="vector"
            className="bottomBarStarIcon"
          >
            <path
              id="path"
              d="M 10.365 0.773 L 7.53 6.52 L 1.189 7.444 C 0.052 7.609 -0.404 9.011 0.421 9.814 L 5.009 14.284 L 3.924 20.599 C 3.728 21.741 4.931 22.596 5.938 22.062 L 11.61 19.08 L 17.283 22.062 C 18.29 22.592 19.492 21.741 19.297 20.599 L 18.212 14.284 L 22.799 9.814 C 23.624 9.011 23.168 7.609 22.031 7.444 L 15.69 6.52 L 12.856 0.773 C 12.348 -0.251 10.877 -0.264 10.365 0.773 Z"
              fill={colorStarIcon ? "#ff4545" : "#ffffff"}
            />
          </svg>
        </Link>
        <Link to="/shop" className="link">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 23 22"
            id="vector"
            className="bottomBarShopIcon"
          >
            <path
              id="path"
              d="M 8.619 21 C 9.145 21 9.571 20.574 9.571 20.048 C 9.571 19.522 9.145 19.095 8.619 19.095 C 8.093 19.095 7.667 19.522 7.667 20.048 C 7.667 20.574 8.093 21 8.619 21 Z"
              fill="#00000000"
              stroke={colorCartIcon ? "#ff4545" : "#ffffff"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="path_1"
              d="M 19.095 21 C 19.621 21 20.048 20.574 20.048 20.048 C 20.048 19.522 19.621 19.095 19.095 19.095 C 18.569 19.095 18.143 19.522 18.143 20.048 C 18.143 20.574 18.569 21 19.095 21 Z"
              fill="#00000000"
              stroke={colorCartIcon ? "#ff4545" : "#ffffff"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="path_2"
              d="M 1 1 L 4.809 1 L 7.362 13.752 C 7.449 14.191 7.688 14.585 8.036 14.865 C 8.384 15.145 8.82 15.294 9.267 15.286 L 18.524 15.286 C 18.971 15.294 19.407 15.145 19.755 14.865 C 20.103 14.585 20.341 14.191 20.429 13.752 L 21.952 5.762 L 5.762 5.762"
              fill="#00000000"
              stroke={colorCartIcon ? "#ff4545" : "#ffffff"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
        <Link to="/userPanel" className="link">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="bottomBarUserIcon"
            viewBox="0 0 24 24"
            id="vector"
          >
            <path
              id="path"
              d="M 12 12 C 14.21 12 16 10.21 16 8 C 16 5.79 14.21 4 12 4 C 9.79 4 8 5.79 8 8 C 8 10.21 9.79 12 12 12 Z M 12 14 C 9.33 14 4 15.34 4 18 L 4 20 L 20 20 L 20 18 C 20 15.34 14.67 14 12 14 Z"
              fill={colorUserIcon ? "#ff4545" : "#FFF"}
            />
          </svg>
        </Link>
      </div>
    </div>
  );
}
